export const getImgUrl = (src: string | undefined) => {
  if (!src) return undefined;
  if (src?.startsWith('blob:')) return src;
  return `https://res.cloudinary.com/cflin/image/upload/${src}`;
};
